// PageDescription: 질환백과 과목 선택 페이지
import { CustomPageProps } from '@/types/app';
import {
  DiseaseEncyclopediaSelectSubjectView,
  useDiseaseEncyclopediaSelectSubjectViewModel,
} from '@/views/disease-encyclopedia/select-subject';

const DiseaseEncyclopediaSelectSubjectPage = ({ client }: CustomPageProps) => {
  const viewModel = useDiseaseEncyclopediaSelectSubjectViewModel();

  return <DiseaseEncyclopediaSelectSubjectView viewModel={viewModel} client={client} />;
};

export default DiseaseEncyclopediaSelectSubjectPage;
